export default __webpack_public_path__ + "static/media/ic-agency-active.c4884971.webp";